<div class="metadata-footer">
  @if (createdAt) {
    <div class="metadata-item">
      <span class="metadata-label">Aangemaakt op</span>
      <span class="metadata-value">{{ createdAt.toString() | readableDateTime }}</span>
      @if (createdByDisplayName) {
        <span class="metadata-value">
          door {{ createdByDisplayName }}
        </span>
      }
    </div>
  }
  @if (hasBeenUpdated) {
    <div class="metadata-item">
      <span class="metadata-label">Laatst gewijzigd op</span>
      <span class="metadata-value">{{ updatedAt.toString() | readableDateTime }}</span>
      @if (updatedByDisplayName) {
        <span class="metadata-value">
          door {{ updatedByDisplayName }}
        </span>
      }
    </div>
  }
</div>
